import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageZoomComponent } from './image-zoom.component';
import { IconsModule } from 'lib/modules/feather-icons.module';

@NgModule({
    declarations: [ImageZoomComponent],
    imports: [CommonModule, IconsModule],
    exports: [ImageZoomComponent],
})
export class ImageZoomModule {}
